import { defaultStyles } from 'react-file-icon';
import type { DefaultExtensionType } from 'react-file-icon';

const isKnownIconExtension = (extension: string): extension is DefaultExtensionType =>
  Object.prototype.hasOwnProperty.call(defaultStyles, extension);

export { isKnownIconExtension };
